// Bulk Reporting Tool (ASB-3991): what the user reads for each error the
// /bulk-reports API can answer with. The API's error body is
// { "message": "<code>" }; apiClient puts it on error.data and error.message
// and the HTTP status on error.status. One map for the form (ASB-4294) and the
// job flow (ASB-4295).

export const UNAVAILABLE_MESSAGE =
	"Reports are unavailable right now. Try again in a few minutes. If it continues, contact AMS support.";
export const TOO_MANY_JOBS_MESSAGE =
	"You already have three reports in progress across your ArcTags. Wait for one to finish, then try again.";
export const FALLBACK_MESSAGE = "Something went wrong. Try again. If it continues, contact AMS support.";

export const BULK_REPORT_ERRORS = {
	// 400
	invalid_request: "The report request was not valid. Check your selections and try again.",
	invalid_filters: "One of the filters is not valid for this campaign. Change the filters and try again.",
	invalid_sections: "Choose at least one valid data type and try again.",
	range_before_available_from:
		"The date range starts before the earliest available data. Choose a later Date Range Start.",
	tag_id_required: "The report request was not valid. Refresh the page and try again.",
	invalid_status: "The report list could not be loaded. Refresh the page and try again.",
	invalid_page: "The report list could not be loaded. Refresh the page and try again.",
	invalid_per_page: "The report list could not be loaded. Refresh the page and try again.",
	// 403
	forbidden: "You do not have access to reports for this ArcTag.",
	bulk_reporting_disabled: "The Bulk Reporting Tool is not turned on for this publisher.",
	not_owner: "Only the person who requested this report can do that.",
	// 404
	tag_not_found: "This ArcTag could not be found. Choose another ArcTag and try again.",
	order_not_found: "This campaign has no data in the available period. Choose another campaign.",
	no_data: "No report data is available for this ArcTag yet.",
	not_found: "This report could not be found.",
	not_ready: "This report is not ready yet.",
	// 409
	terminal: "This report has already finished.",
	not_failed: "Only a failed report can be dismissed.",
	// 410
	expired: "This report has expired. Generate it again.",
	// 429
	too_many_jobs: TOO_MANY_JOBS_MESSAGE,
	// 503
	snowflake_unavailable: UNAVAILABLE_MESSAGE,
	not_configured: UNAVAILABLE_MESSAGE,
	start_failed: UNAVAILABLE_MESSAGE,
};

// The API's code for an apiClient error, or null when the error carries none
// (a network failure, a non-JSON gateway page).
export function bulkReportErrorCode(error) {
	const code = error?.data?.message;
	return typeof code === "string" && code ? code : null;
}

// The copy for an error from any /bulk-reports call. Every 503 reads as
// "unavailable" and every 429 as the three-report limit, whatever the code.
export function bulkReportErrorMessage(error) {
	if (error?.status === 503) return UNAVAILABLE_MESSAGE;
	if (error?.status === 429) return TOO_MANY_JOBS_MESSAGE;
	const code = bulkReportErrorCode(error);
	if (code && Object.prototype.hasOwnProperty.call(BULK_REPORT_ERRORS, code)) return BULK_REPORT_ERRORS[code];
	return FALLBACK_MESSAGE;
}
